// extracted by mini-css-extract-plugin
module.exports = {"dialog":"styles_dialog__30wEE","container":"styles_container__zdN3X","iconButton":"styles_iconButton__1q2dT"};